<template>
  <v-col>
    <!-- Gallery data table -->
    <gallery-table
      :key="index"
      no-search
      url-api="/gallery"
      :headers="headers"
    >
      <!-- New new bill -->
      <template v-slot:urlCreate="{ item }">
        <v-card outlined>
          <v-card-text>
            <v-tabs>
              <v-tab>Upload Photo</v-tab>
              <v-tab>Upload Video</v-tab>
              <v-tab-item>
                <v-col cols="12">
                  <v-text-field
                    v-model="title"
                    label="Image Title/Caption"
                    :error-messages="errors.getMessage('title')"
                  />
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    v-model="upload"
                    label="Select image file"
                    :error-messages="errors.getMessage('logo')"
                    accept="image/jpg, image/png, image/jpeg"
                  />
                </v-col>
                <v-col cols="12">
                  <v-btn
                    :disabled="!title || !upload"
                    @click="createNew(0)"
                  >
                    Create
                  </v-btn>
                </v-col>
              </v-tab-item>
              <v-tab-item>
                <v-col cols="12">
                  <v-text-field
                    v-model="title"
                    label="Video Title/Caption"
                    :error-messages="errors.getMessage('title')"
                  />
                </v-col>
                <v-col cols="12">
                  <v-file-input
                    v-model="upload"
                    label="Select Video (mp4)"
                    :error-messages="errors.getMessage('logo')"
                    accept="video/mp4"
                  />
                </v-col>
                <v-col cols="12">
                  <v-btn
                    :disabled="!title || !upload"
                    @click="createNew(1)"
                  >
                    Create
                  </v-btn>
                </v-col>
              </v-tab-item>
            </v-tabs>
          </v-card-text>
        </v-card>
      </template>
      <!-- end -->

      <!-- Image -->
      <template v-slot:image="{ item }">
        <v-img
          :src="
            item.type
              ? '/storage/default_img/play.jpg'
              : '/storage/' + item.image
          "
          lazy-src="/storage/default_img/no_image.png"
          aspect-ratio="1"
          max-width="75"
          max-height="75"
        />
      </template>
      <!-- end -->

      <!-- ColumnActions -->
      <template v-slot:columnaction="{ item }">
        <!-- Gallery Item remove -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn
              small
              icon
              @click="warningItemRemove(item)"
              v-on="on"
            >
              <v-icon>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
        <!-- end -->
      </template>
      <!-- end columnActions -->
    </gallery-table>

    <!-- end data table -->

    <!-- Remove warning -->
    <v-dialog
      v-model="ItemRemoveWarning"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          Warning
        </v-card-title>
        <v-card-text>
          Are you sure to remove ?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="ItemRemoveWarning = false"
          >
            Cancel
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="removeItem"
          >
            Remove
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- end -->
  </v-col>
</template>

<script>
import GalleryDataTable from "../common/DataTable.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    "gallery-table": GalleryDataTable,
  },
  data() {
    return {
      upload: null,
      title: "",
      type: "",
      item: {},
      ItemRemoveWarning: false,
      index: 1,

      headers: [
        {
          text: "Added At",
          align: "start",
          sortable: true,
          value: "created_at",
        },
        {
          text: "image",
          sortable: true,
          value: "image",
          slot: "image",
        },

        {
          text: "Title",
          sortable: false,
          value: "title",
        },

        {
          text: "Actions",
          sortable: false,
          slot: "columnaction",
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },

  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    createNew(isImage) {
      if (this.upload !== null) {
        const formData = new FormData();
        formData.append("image", this.upload, this.upload.name);
        formData.append("title", this.$data.title);
        formData.append("type", isImage);
        window.axios.post("/gallery", formData).then((response) => {
          if (response.data.updated) {
            this.$data.index++;
            this.$data.upload = null;
            this.$data.title = null;
            this.$data.type = false;
            this.feedback(response.data.message);
          }
        });
      }
    },
    removeItem() {
      window.axios.delete("/gallery/" + this.$data.item.id).then((response) => {
        this.feedback(response.data.message);
        this.ItemRemoveWarning = false;
        this.$data.index++;
      });
    },

    warningItemRemove(item) {
      this.$data.item = item;
      this.ItemRemoveWarning = true;
    },
  },
};
</script>
